import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('[Bourbon] App is ready for offline use!');
  },
  onUpdate: (registration) => {
    // The <UpdateBanner /> in App listens for this and lets the user refresh when ready
    window.dispatchEvent(new CustomEvent('bourbon:sw-update', { detail: registration }));
  }
});
